import React, { useContext } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { CapaQuotationChatRoomAnnotationComment } from '@generated/graphql';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { NoAnnotationIcon } from '../assets';
import AnnotationListEntry from './AnnotationListEntry';
import { TutorialContext } from '@routes/CapaViewTutorial/CapaViewTutorial';

export interface AnnotationListProps {
  annotations: CapaQuotationChatRoomAnnotationComment[];
  onClickAnnotation: (e: any, fileId: string, annotationId: string) => void;
}

const AnnotationList: React.FunctionComponent<AnnotationListProps> = ({
  annotations,
  onClickAnnotation
}) => {
  const tutorialAnnotationComments = useContext(TutorialContext);

  // 튜토리얼에서 불러온 AnnotationList일 경우 useFetchQuotationChatRoomAnnotationCommentsQuery를 불러오지 않고 tutorialAnnotationComments으로 렌더링
  const annotationList: CapaQuotationChatRoomAnnotationComment[] = tutorialAnnotationComments
    ? tutorialAnnotationComments
    : annotations;

  const noAnnotation = annotationList.length === 0;
  const { listContainer, noItemNoticeContainer } = useStyles({
    noItem: noAnnotation
  });

  return (
    <div className={listContainer}>
      {noAnnotation && (
        <div className={noItemNoticeContainer}>
          <img src={NoAnnotationIcon} alt="주석이 없습니다." />
          <CustomizedTypography
            variant="body2"
            color="textSecondary"
            fontWeight="500"
          >
            뷰어 하단의 <strong>‘주석달기’</strong> 기능을 통해 <br />
            도면 특정 부분에 주석을 달 수 있어요
          </CustomizedTypography>
        </div>
      )}
      {annotationList.map((annotation) => {
        return (
          <AnnotationListEntry
            key={annotation.annotationId}
            onClickAnnotation={onClickAnnotation}
            annotation={annotation}
          />
        );
      })}
    </div>
  );
};

export default AnnotationList;

const useStyles = makeStyles<Theme, { noItem: boolean }>((theme) => ({
  listContainer: {
    overflow: 'auto'
  },
  noItemNoticeContainer: {
    marginTop: 64,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '142px',
      height: '142px'
    },
    '& strong': {
      color: colorSet.primary500
    }
  }
}));
